import React, { Component } from 'react'
import { compose } from 'recompose'
import { withStyles } from '@material-ui/core/styles';
import { ExpansionPanel, Button } from '@material-ui/core';

import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';

class FiltroConsulta extends Component {
    constructor(props) {
        super(props)
        this.filtrar = this.filtrar.bind(this)
        this.state = {}
    }

    filtrar(props) {
        let lista_pesquisa = [];
        if (this.props.lista) {
            lista_pesquisa = this.props.lista.slice();
        }

        let listaFiltrada = lista_pesquisa.filter(obj => {
            let b = true;
            for (var f in props) {
                if (!b) {
                    return false;
                }
                if (props[f]) {
                    if (props[f].atende) {
                        b = props[f].atende(b, obj, props[f]);
                    } else {
                        // b = this.props[f + "Atende"](b, obj, props[f]);
                        if (this.props.children) {
                            this.props.children.forEach(child => {
                                let filtro = child.props;
                                if (filtro) {
                                    if (filtro.name === f) {


                                        if (filtro.atende) {
                                            b = filtro.atende(obj, props[f]);
                                        }
                                    }
                                }


                            })
                        }
                    }
                }
            };
            return b;
        });



        this.props.filtrou(listaFiltrada);
    }

    render() {
        const { classes, filtros } = this.props;
        let resumoFiltros = "";
        return (
            <ExpansionPanel
                className={classes.root}
            >
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} style={{ justifyContent: "space-between", paddingRight: 25 }}>
                    <div style={{ display: "flex", alignItems: 'center' }}>
                        <Typography className={classes.heading}>Filtros</Typography>
                        <Button variant="contained" color="primary" size="small" onClick={this.props.handleSubmit(this.filtrar)}>Filtrar</Button>
                    </div>
                    <Typography className={classes.secondaryHeading}>{resumoFiltros}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails style={{ justifyContent: "space-between", flexWrap: 'wrap' }} >
                    {filtros}
                </ExpansionPanelDetails>
            </ExpansionPanel>
        )
    }
}

const styles = theme => ({
    root: {
        overflow: 'visible'
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
        paddingRight: 10
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    teste: {
        backgroundColor: '#0f0',
    },
});




export default compose(
    connect((state, props) => ({
        form: "filtros" + props.titulo
    })),
    reduxForm(),
    withStyles(styles)
)(FiltroConsulta);


// WEBPACK FOOTER //
// ./src/components/ConsultaCrud/FiltrosConsulta.js